export default __webpack_public_path__ + "static/media/hrms.a09ac3d3.svg";